require('./records-template.html');

angular.module('bbl.module.call-records.controller', [])
.controller('CallRecordsController', [
  '$scope', 'Conference', 'ConferenceCalls', 'Modal', '$http', '$window', 'Api', '$timeout',
  callRecordsController
]);

function callRecordsController($scope, Conference, ConferenceCalls, Modal, $http, $window, Api, $timeout) {
  $scope.PAGINATION = {
    curPage: 1,
    items: 0,
    perPage: 10
  };
  $scope.SORT = {
    column: 'created',
    descending: true
  };
  $scope.COLUMNS = {
    aname: 'Line',
    created: 'Date',
    time_unix: 'Time',
    total_minutes: 'Minutes',
    total_callers: 'Callers',
    billing_code: 'Billing Code',
  };

  $scope.fetchItems = function (opts) {
    var query = angular.extend({}, {
      offset: ($scope.PAGINATION.curPage - 1) * $scope.PAGINATION.perPage,
      limit: $scope.PAGINATION.perPage
    }, opts);

    Conference.query(query).$promise.then(function(response) {
      for(var i = 0; i < response.objects.length; i++) {
        var conf = response.objects[i];
        conf.line_name = conf.line;
        conf.room_name = conf.room;
        conf.total_minutes = conf.minutes;
        conf.total_callers = conf.callers;
        conf.record_length = parseInt(conf.record_length);

        conf.conference_started =  moment(conf.created).format();
      }
      $scope.MODEL = response;
      $scope.MODEL.visibleItems = $scope.MODEL.objects;
      $scope.PAGINATION.items = response.meta.total_count;
    });
  };

  $scope.fetchItems();

  $scope.loadPage = function(page) {
    // if page doesn't exist or current page isn't the passed page
    if(!(page !== undefined && ($scope.PAGINATION.curPage = page))) {
     page = $scope.PAGINATION.curPage;
    }

    $scope.PAGINATION.curPage = page;
    $scope.fetchItems();
  };

  $scope.selectedCls = function(column) {
    return column == $scope.SORT.column && $scope.SORT.descending;
  };
  $scope.isShortCl = function(column) {
    return column != 'aname';
  };
  $scope.changeSorting = function(column) {
    var sort = $scope.SORT;
    if(sort.column == column) {
      sort.descending = !sort.descending;
    } else {
      sort.column = column;
      sort.descending = false;
    }
    $scope.PAGINATION.curPage = 1;
    $scope.fetchItems();
  };

  $scope.filterCalls = function() {
    var search = $scope.searchCall.replace(/[\W]/g, '\\$&');
    $scope.fetchItems({filter: search});
  };

  $scope.toggleCallInfo = function($event, sid) {
    var btn = $($event.currentTarget);
    btn.closest('table').find('tr[data-sid='+sid+']').find('.toggle-more-call-info').slideToggle(400, function() {

    });
  };

  $scope.showModal = function(conference) {
    Modal.show({
      title: conference.name,
      type: 'call_records',
      conference: conference
    });
  };

  $scope.intercomEvent = function(evt) {
    if($window.Intercom) {
      $window.Intercom('trackEvent', evt);
    }
  };

  $scope.intercomMsg = function(msg) {
    if($window.Intercom) {
      $window.Intercom('showNewMessage', msg);
    }
  };

  $scope.showTranscriptModal = function(conference){
    $scope.submited = false;
    $scope.record_length = Math.floor(conference.record_length/60);
    var modalElement = jQuery(angular.element.find('#transcriptModal'));
    modalElement.modal('show');
    $scope.closeTranscripModal = function(){modalElement.modal('hide');};

    $scope.transcribeRecord = function() {
      $http({
        url: '/bridges/api/v1/transcript_approved/'+conference.id+'/?format=json',
        method: "GET"
      }).then(function() {
        $scope.submited = true;
      }, function() {
      });
    };
  };

  $scope.formatByTimezone = function(date, format){
    return moment(date).parseZone().format(format);
  };

  $scope.getBridge = function() {};

  $scope.saveCallName = function(call) {
    ConferenceCalls.changeCall({conferenceCallId: call.id}, {
      name: call.name,
      sid: call.sid
    });
  };

  $scope.toDate = function(dateStr) {
    return new Date(dateStr);
  };

  $scope.getEndTime = function(call) {
    return new Date((+new Date(call.start_time) + call.duration*60*1000));
  };

  Api.bridges.sub(function(bridges) {
    $scope.getBridge = function(conf) {
      return bridges.filter(function(b) {return b.id+'' === conf.bridge_id+'';})[0];
    };
  });

  Api.bridges.fetch();
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/call-records/call-records.controller.js
 ** module id = 362
 ** module chunks = 0
 **/